export const getEmailTagViewStyle = () => ({
  container: {
    fontSize: '14px',
    marginLeft: 26,
    marginBottom: 12,
    '& .email-text-area': {
      width: 440,
      marginTop: 20,
    },
    '& .show-error': {
      color: 'red',
    },
    '& .send-email': {
      marginTop: 20,
    },
    '& .email-template-link': {
      marginLeft: 16,
      marginTop: 25,
    },
    '& .ms-Panel-commands': {
      marginBottom: 39,
    },
  },
  panel: {
    fontSize: '16px',
  },
});

export const emailTagPanelStyles = {
  panel: {
    footerInner: { borderTop: '1px #EDEBE9 solid' },
    header: { paddingLeft: 16, paddingTop: 0, marginTop: '0 !important' },
    width: {
      Container: '480px',
      DMC: '480px',
      UET: '700px',
    },
    content: {
      paddingBottom: '80px',
    },
  },
};
